import { useState } from 'react';
import { Menu } from 'lucide-react';
import {
  Sheet,
  SheetContent,
  SheetDescription,
  SheetHeader,
  SheetTitle,
  SheetTrigger,
} from '@/components/ui/sheet';
import SideBarCreateWebinar from './SideBarCreateWebinar';
import { useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function MobileSideBarCreateWebinar() {
  const [open, setOpen] = useState(false);
  const { t } = useTranslation('common');
  const [searchParams] = useSearchParams();
  const duplicateWebinarId = searchParams.get('duplicateWebinarId');
  if (duplicateWebinarId) {
    return null;
  }
  return (
    <Sheet open={open} onOpenChange={setOpen}>
      <SheetTrigger asChild>
        <button
          className="inline-flex h-9 w-9 items-center justify-center rounded-md border border-black/20 backdrop-blur-md bg-white/20 text-gray-800 hover:bg-white/30 lg:hidden transition-colors"
          aria-label={t('navigation.open')}
        >
          <Menu className="h-5 w-5" />
        </button>
      </SheetTrigger>
      <SheetContent side="left" className="w-[280px] p-3">
        <SheetHeader className="sr-only">
          <SheetTitle>{t('navigation.createWebinarTitle')}</SheetTitle>
          <SheetDescription>{t('navigation.createWebinarDescription')}</SheetDescription>
        </SheetHeader>
        <SideBarCreateWebinar mobile onNavigate={() => setOpen(false)} />
      </SheetContent>
    </Sheet>
  );
}
